var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareForwardLine = function SvgShareForwardLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.4 13.8h-1.8a8.1 8.1 0 0 0-7.171 4.328A9 9 0 0 1 13.4 8.4V3.45l9.45 7.65-9.45 7.65zM11.6 12h3.6v2.976l4.789-3.877L15.2 7.222v2.977h-1.8a7.19 7.19 0 0 0-5.451 2.496 9.9 9.9 0 0 1 3.651-.696Z"
  })));
};
export default SvgShareForwardLine;